// GENERATED FILE - DO NOT MODIFY

export enum GetVenueSalesReportSortColumnDto {
    VenueName = "VenueName",
    OperatorCompanyName = "OperatorCompanyName",
    YearTotal = "YearTotal",
    MonthTotal = "MonthTotal",
}